import { useEffect, useState } from "react";
import api from "../api";

export default function usePermissions() {
  const [loading, setLoading] = useState(true);
  const [permissions, setPermissions] = useState({
    stories: false,
    topNews: false,
    awards: false,
    dealer: false,
    service: false,
    flightScanUsers: false,
    odoMateUsers: false,
    mailTemplates: false,
    tagManagement: false,
    superAdmin: false,
    homeTestRide: false,
    wallpaper: false,
    uvMissions: false,
    notifications: false,
  });

  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const { data } = await api.get('/api/test/permissions');
        const perms = data.permissions;

        console.log("Perms:", perms);

        const hasPermission = (pattern) =>
          perms.some(p => new RegExp(pattern).test(p));

        setPermissions({
          stories: hasPermission('^read_story$'),
          topNews: hasPermission('^read_top_news$'),
          awards: hasPermission('^read_awards$'),
          dealer: hasPermission('^read_dealershipmaster$'),
          service: hasPermission('^read_service$'),
          flightScanUsers: hasPermission('^read_flightscan$'),
          odoMateUsers: hasPermission('^read_odomate$'),
          mailTemplates: hasPermission('^template_user$'),
          tagManagement: hasPermission('^read_tags$'),
          superAdmin: hasPermission('^SUPER ADMIN$'),
          homeTestRide: hasPermission('^read_htr$'),
          wallpaper: hasPermission('^read_wallpaper$'),
          odoMateUsers: hasPermission('^read_odomate$'),
          uvMissions: hasPermission('^read_uv_mission$'),
          notifications: hasPermission('^read_notification$'),
        });
      } catch (error) {
        console.error('Error fetching permissions:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchPermissions();
  }, []);

  return { permissions, loading };
}
